// @ts-strict-ignore
import { clinicCommon } from "@clinic/shared/locales/en/US/clinicCommon";
import { sharedCommon } from "@shared/locales/en/US/sharedCommon";

const common = {
  ProductOutOfStockOrDiscontinued:
    "This product cannot be purchased or prescribed because it is out of stock or discontinued",
  UnavailableForWholesale: "Unavailable for wholesale",
  OutOfStock: "Out of stock",
  Cancel: "Cancel",
  Delete: "Delete",
  Save: "Save",
  NumItems: "{{quantity}} item",
  NumItemsPlural: "{{quantity}} items",
  ...sharedCommon,
  ...clinicCommon,
} as const;

export { common };
